import { Form, Button, Typography, Flex, Grid, Radio } from "antd";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";

import { useForm } from "antd/es/form/Form";
import { useDispatch, useSelector } from "react-redux";
import { saveCrmCustomer } from "../crmCustomersThunks";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { fetchLocations } from "../../../store/commonThunks/lookups";
import { selectLocations } from "../../../store/commonSelectors/lookupsSelectors";
import { createCrmCustomerPayload } from "../../../utils/crmCustomers";
import Dropdown from "../../../components/DropDown/DropDown";
import InputField from "../../../components/Input/Input";
import { getAccessType } from "../../../lib/functions";
import "./customer.css";
import { getISOFromCountryName } from "../../../lib/currency";

const { Title } = Typography;
const { useBreakpoint } = Grid;

const customersType = [
  { label: "Retailer", value: "retailer" },
  { label: "Wholesaler", value: "wholesaler" },
  { label: "Distributor", value: "distributor" },
  { label: "Corporate", value: "corporate" },
];

const CreateCrmCustomerForm = ({authInfo}) => {
  const [form] = useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const screens = useBreakpoint();

  const { isEditCustomer, selectedCustomer } = useSelector(
    (s) => s.crmCustomers
  );
  const locations = useSelector(selectLocations);
  const { user } = useSelector((s) => s.auth);
  let [access_type, access_type_set] = useState("");

  useEffect(() => {
    const access = getAccessType("crm_customer_entry");
    access_type_set(access);
  }, []);

  useEffect(() => {
    dispatch(fetchLocations());
  }, [dispatch]);

  useEffect(() => {
    if (isEditCustomer && selectedCustomer) {
      form.setFieldsValue({
        ...selectedCustomer,
        acc_id: selectedCustomer.acc_id,
      });
    }
  }, [isEditCustomer, selectedCustomer]);

  const handleSave = (values) => {
    const payload = createCrmCustomerPayload(values, user);
    dispatch(saveCrmCustomer(payload));
    navigate(location?.state?.from || "/crm/customers");
  };

  const handleCancel = () => navigate(-1);

  const defaultCountry = getISOFromCountryName(authInfo?.country);

  return (
    <div className="invoice-form">
      <Title level={2} style={{ marginBottom: "44px" }}>
        {isEditCustomer ? "Update CRM Customer" : "Create CRM Customer"}
      </Title>

      <Form
        form={form}
        layout="horizontal"
        onFinish={handleSave}
        initialValues={{
          party_type: "retailer",
        }}
        style={{ maxWidth: "1400px" }}
        className="responsive-form"
        colon={false}
        // labelCol={{ span: 8 }}
        // wrapperCol={{ span: 18 }}
           labelCol={{
          xs: { span: 24 },
          sm: { span: 8 },
          md: { span: 8 },
          lg: { span: 6 },
          xl: { span: 9 },
          xxl: { span: 6 },
        }}
        wrapperCol={{
          xs: { span: 24 },
          sm: { span: 16 },
          md: { span: 16 },
          lg: { span: 18 },
          xl: { span: 15 },
          xxl: { span: 16 },
        }}
      >
       
        {/* Customer Type */}
        <Flex
          style={{
            width: !screens.md || !screens.xl ? "100%" : "61%",
            marginBottom: "32px",
            justifyContent: "flex-start",
          }}
        >
          <Form.Item
            label="Customer Type*"
            name="party_type"
            style={{ width: "100%" }}
          >
            <Radio.Group options={customersType} />
          </Form.Item>
        </Flex>

        {/* Form Fields */}
        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="center"
          style={{
            flexDirection: !screens.md || !screens.xl ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          {/* Left side */}
          <Flex
            vertical
            gap={10}
            style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}
          >
            <Form.Item name="acc_id" hidden>
              <InputField />
            </Form.Item>
            <Form.Item
              label="Customer Name"
              name="acc_name"
              className="customer-form"
              rules={[{ required: true, message: "Customer Name is Required" }]}
            >
              <InputField
                placeholder="Customer Name"
                data-testid="customer-name-input"
              />
            </Form.Item>

            <Form.Item
              label="Institution Name"
              name="institution_name"
              className="customer-form"
            >
              <InputField
                placeholder="Institution"
                data-testid="customer-institution-input"
              />
            </Form.Item>

            <Form.Item
              label="Contact No"
              className="customer-form"
              required
              rules={[
                { required: true, message: "Contact number is required" },
                {
                  pattern: /^[0-9]{6,15}$/, // allow 6–15 digits
                  message: "Please enter a valid phone number",
                },
              ]}
            >
              <PhoneInput
                country={defaultCountry}
                value={
                  form.getFieldValue("country_code")
                    ? `${form.getFieldValue("country_code")}${
                        form.getFieldValue("contact_no") || ""
                      }`
                    : form.getFieldValue("contact_no") || ""
                }
                inputStyle={{
                  width: "100%",
                  height: "39.6px",
                  background: "rgba(0,0,0,0.04)",
                  borderColor: "transparent",
                }}
                placeholder="Contact no"
                onChange={(phone, country) => {
                  // remove dial code from the start → store clean contact number
                  const onlyNumber = phone.startsWith(country.dialCode)
                    ? phone.slice(country.dialCode.length)
                    : phone;

                  form.setFieldValue("contact_no", onlyNumber);
                  form.setFieldValue("country_code", country.dialCode);
                }}
                data-testid="customer-phone-input"
              />
            </Form.Item>

            {/* Hidden fields actually bound to the Form */}
            <Form.Item name="contact_no" hidden>
              <InputField />
            </Form.Item>
            <Form.Item name="country_code" hidden>
              <InputField />
            </Form.Item>

            <Form.Item name="contact_no" hidden>
              <InputField />
            </Form.Item>

            <Form.Item
              label="Expectation %"
              name="expectation_per"
              className="customer-form"
              rules={[
                {
                  validator: (_, value) => {
                    if (!value) return Promise.resolve(); // ✅ allow empty
                    if (/^(100|[1-9]?[0-9])$/.test(value)) {
                      return Promise.resolve(); // ✅ valid 0–100
                    }
                    return Promise.reject(
                      new Error("Enter a valid percentage (0–100)")
                    );
                  },
                },
              ]}
            >
              <InputField
                placeholder="Expectation %"
                data-testid="customer-expectation-input"
              />
            </Form.Item>

            <Form.Item
              label="Email Address"
              name="email_address"
              className="customer-form"
              rules={[
                {
                  type: "email",
                  message: "Please enter a valid email address",
                },
                {
                  required: true,
                  message: "Email is required",
                },
              ]}
            >
              <InputField
                placeholder="Email"
                data-testid="customer-email-input"
              />
            </Form.Item>
          </Flex>

          {/* Right side */}
          <Flex
            vertical
            gap={10}
            style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}
          >
            <Form.Item
              label="Profession"
              name="profession"
              className="customer-form"
            >
              <InputField
                placeholder="Profession"
                data-testid="customer-profession-input"
              />
            </Form.Item>

            <Form.Item label="Address" name="address" className="customer-form">
              <InputField
                placeholder="Address"
                data-testid="customer-address-input"
              />
            </Form.Item>

            <Form.Item
              label="Location/Area"
              name="location_id"
              className="customer-form"
            >
              <Dropdown
                placeholder="Select a Location/Area"
                data-testid="customer-location-input"
                options={locations.map((el) => ({
                  label: el.location_name,
                  value: el.location_id,
                }))}
              />
            </Form.Item>

            <Form.Item
              label="Initial Conversation"
              name="conversation"
              className="customer-form"
            >
              <InputField
                placeholder="Initial Conversation"
                data-testid="customer-conversation-input"
              />
            </Form.Item>
          </Flex>
        </Flex>
        <Form.Item
          style={{
            marginTop: "24px",
          }}
        >
          <Flex style={{ marginBottom: "32px", width: "25%" }} gap={32}>
            <Button
              size="large"
              shape="default"
              onClick={handleCancel}
              className="traic-button"
            >
              Back
            </Button>
            {access_type == "WRITE" && (
              <>
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  className="traic-button"
                  data-testid="save-customer-btn"
                >
                  {isEditCustomer ? "Update" : "Save"}
                </Button>
              </>
            )}
          </Flex>
        </Form.Item>
      </Form>
    </div>
  );
};

export default CreateCrmCustomerForm;
